import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectLanguage } from "../../redux/language/selector";

const PdfViewer2 = () => {
  const { t } = useTranslation();

  const language = useSelector(selectLanguage);

  useEffect(() => {
    document.title = t("pdf.thuthap");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [language]);
  return (
    <div style={{ height: "100vh", width: "100%" }}>
      <iframe
        src={language === "vi" ? "/uploads/GoPaperless_ChinhsachthuthapvaxulydulieucanhanV02.pdf":"/uploads/GoPaperless_Chính_sách_Thu_thập_và_Xử_lý_DL_cá_nhân_ENG_260813.pdf"}
        width="100%"
        height="100%"
        style={{ border: "none" }}
        title="GoPaperless_ChínhSáchThuThậpVàXửLýDữLiệuCáNhân"
      ></iframe>
    </div>
  );
};

export default PdfViewer2;
